import { FieldInputProps, useField, useFormikContext } from "formik";
import React from "react";

import { FieldHeaderProps, FieldStateProps } from "../FieldHeader";
import { TextField } from "../TextField";
import { useSetFieldTouched } from "../useSetFieldTouched";

type NumericInputFieldProps = Readonly<{
  name: string;
  minValue?: number;
  maxValue?: number;
}> &
  FieldHeaderProps &
  FieldStateProps;

export const NumericInputField = (props: NumericInputFieldProps) => {
  const { minValue, maxValue, disabled, isSaving, isRequiredField } = props;

  const { setFieldValue } = useFormikContext();
  const [field] = useField(props);

  useSetFieldTouched(field.name);

  const onNumberChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    // eslint-disable-next-line
    field: FieldInputProps<any>
  ) => {
    if (!minValue && !maxValue) {
      return field.onChange;
    }
    const targetValue = Number(e.target.value);
    const clampedValue =
      targetValue < (minValue ?? 0) ? null : Math.min(targetValue, maxValue ?? Infinity);
    setFieldValue(field.name, clampedValue);
    return field.onChange;
  };

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (["e", "E", ".", "+", "-"].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <TextField
      {...props}
      isRequiredField={isRequiredField}
      disabled={disabled}
      isSaving={isSaving}
      customOnChange={onNumberChange}
      customOnKeyDown={onKeyDown}
      type="number"
    />
  );
};
